<template>
    <div id="similar-recipes" class="row">
        <div class="col">
            <h3 class="mb-4">Similar Recipes</h3>
            <div class="row">
                <div
                    class="col-sm-4 mb-4"
                    v-for="recipe in recipes"
                    v-bind:key="recipe.id"
                >
                    <recipe-card :recipe="recipe" :show_category="1" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RecipeCard from "./RecipeCard.vue";
export default {
    components: { RecipeCard },
    name: "SimilarRecipes",
    props: ["recipes"],
    data() {
        return {};
    },
};
</script>
<style scoped></style>
